// @flow

import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  USER_PROFILE_SUCCESS,
  USER_PROFILE_REQUEST,
  USER_PROFILE_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
} from './constant';

const initialState = {
  profile: null,
  loginError: {
    statusCode: -1,
    message: null,
  },
  changePassword: {
    oldPassword: '',
    newPassword: '',
    statusCode: -1,
    errorMessage: null,
    successMessage: null,
  },
  forgotPassword: {
    email: '',
    username: '',
    statusCode: -1,
    errorMessage: null,
    successMessage: null,
  },
};

export default function reducer(state: UserStoreType = initialState, action: ActionType): UserStoreType {
  switch (action.type) {
    case LOGOUT_REQUEST: {
      // Keep current state while logout is in progress
      return {
        ...state,
      };
    }
    case LOGOUT_SUCCESS:
    case LOGOUT_FAILURE: {
      // Clear all user state on logout (success or failure)
      return {
        ...initialState,
      };
    }
    case USER_PROFILE_REQUEST: {
      return {
        ...state,
      };
    }
    case LOGIN_REQUEST: {
      const {
        payload: { user },
      } = action;
      return {
        ...state,
        user,
      };
    }
    case USER_PROFILE_SUCCESS:
    case LOGIN_SUCCESS: {
      const {
        payload: { username, id, role, lotNumber, token },
      } = action;
      return {
        ...state,
        loginError: initialState.loginError,
        profile: {
          username,
          id,
          role,
          lotNumber,
          token,
        },
      };
    }
    case USER_PROFILE_FAILURE: {
      return {
        ...state,
        ...initialState.profile,
      };
    }
    case LOGIN_FAILURE: {
      const {
        payload: { statusCode, message },
      } = action;
      if (message === 'Unauthorized') {
        return {
          ...state,
          ...initialState.profile,
          loginError: {
            statusCode: 401,
            message: 'Invalid username or password',
          },
        };
      }
      return {
        ...state,
        ...initialState.profile,
        loginError: {
          statusCode,
          message: message.includes('wrong password!')
            ? 'No such username or password'
            : message && message.includes('locked')
            ? 'Your account is locked'
            : message,
        },
      };
    }
    case CHANGE_PASSWORD_REQUEST: {
      const {
        payload: { oldPassword, newPassword },
      } = action;
      return {
        ...state,
        changePassword: {
          ...state.changePassword,
          oldPassword,
          newPassword,
        },
      };
    }
    case CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state,
        changePassword: {
          ...state.changePassword,
          successMessage: 'Password sent successfully',
          errorMessage: '',
        },
      };
    }
    case CHANGE_PASSWORD_FAILURE: {
      const {
        payload: { statusCode, message },
      } = action;
      return {
        ...state,
        changePassword: {
          ...state.changePassword,
          successMessage: '',
          statusCode,
          errorMessage: message,
        },
      };
    }
    case FORGOT_PASSWORD_REQUEST: {
      const {
        payload: { email, username },
      } = action;
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          email,
          username,
        },
      };
    }
    case FORGOT_PASSWORD_SUCCESS: {
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          successMessage: 'Password sent successfully',
          errorMessage: null,
          statusCode: 200,
        },
      };
    }
    case FORGOT_PASSWORD_FAILURE: {
      const {
        payload: { statusCode, message },
      } = action;
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          successMessage: null,
          statusCode,
          errorMessage: statusCode === 429 ? message.split(':')[0] : message,
        },
      };
    }
    default:
      return state;
  }
}
